import {useEffect, useState} from 'react';
import type {VideosManifestEntry} from '@/types/videosManifest';
import {findPageVideo} from './videosMenuUtils';

export function useVideosCatalog(pathname: string) {
    const [entries, setEntries] = useState<VideosManifestEntry[] | null>(null);
    const [selectedVideo, setSelectedVideo] = useState<VideosManifestEntry | null>(null);

    useEffect(() => {
        let cancelled = false;

        fetch('/videos/videos-manifest.json')
            .then(res => (res.ok ? res.json() : []))
            .then((data: unknown) => {
                if (!cancelled) {
                    setEntries(Array.isArray(data) ? (data as VideosManifestEntry[]) : []);
                }
            })
            .catch(() => {
                if (!cancelled) setEntries([]);
            });

        return () => {
            cancelled = true;
        };
    }, []);

    const allVideos = entries ?? [];
    const pageVideo = findPageVideo(allVideos, pathname);

    return {
        loaded: entries !== null,
        allVideos,
        pageVideo,
        selectedVideo,
        openVideo: (entry: VideosManifestEntry) => setSelectedVideo(entry),
        closeVideo: () => setSelectedVideo(null),
    };
}
